import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-notifications',
  templateUrl: './content-notifications.component.html',
  styleUrls: ['./content-notifications.component.sass']
})
export class ContentNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
